<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="700"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style=" overflow: auto;padding-bottom: 53px;"
  >
    <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span
          style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right"
        >
          <a-button
            @click="toggleScreen"
            icon="appstore"
            style="height:20px;width:20px;border:0px"
          ></a-button>
        </span>
      </div>
    </template>

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="群活码名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :maxLength="20"
            placeholder="请输入群活码名称"
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入群活码名称!' }] }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="选择群聊"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <!-- {{ form.getFieldValue('chats')}} -->
          <j-select-group
            placeholder="请选择群聊"
            :multiple="true"
            v-decorator="[
              'chats',
              { rules: [{ required: true, message: '请选择群聊!' }] }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="添加标签"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a @click="visibleshow = !visibleshow">点击添加标签</a>
          <div
            v-decorator="[
              'tags',
              { rules: [{ required: true, message: '请选择标签!' }] }
            ]"
          >
            <a-drawer
              title="添加标签"
              width="320"
              :closable="false"
              :visible="visibleshow"
              @close="onCloseTag"
            >
              <a-tree
                multiple
                treeCheckable="tree"
                checkable
                @expand="onExpand1"
                :expandedKeys="channelExpandedKey"
                :checkedKeys="channelCheckedKeys"
                allowClear="true"
                @check="onCheck1"
                :treeData="departTree1"
                :auto-expand-parent="autoExpandParent"
                :replace-fields="{
                  children: 'tags',
                  title: 'name',
                  key: 'id'
                }"
              >
              </a-tree>
            </a-drawer>
          </div>

          <div>
            <a-tag
              v-for="(item, index) in model.tags"
              :key="index"
              closable
              @close.prevent="closeTag(index)"
            >
              {{ item.title }}
            </a-tag>
          </div>
        </a-form-item>
        <!-- <a-form-item label="群维护人员" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a @click="visibleshowuser = !visibleshowuser">点击选择群维护人员</a>
          <a-drawer title="选择人员" width="320" :closable="false" :visible="visibleshowuser" @close="onClose">
            <a-input-search v-model="popSearchValue" style="margin-bottom: 8px" placeholder="搜索"
              @change="onChangeUser" />
            <a-tree multiple treeCheckable="tree" checkable @expand="onExpand" :expandedKeys="expandedKey"
              :checkedKeys="checkedKeys" allowClear="true" @check="onCheck"
              :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }" :treeData="departTree" placeholder="请选择上级部门"
              v-decorator="['userList', { rules: [{ required: true, message: '请选择人员!' }] }]"
              :auto-expand-parent="autoExpandParent">
            </a-tree>
          </a-drawer>
          <div>
            <a-tag v-for="(item, index) in model.userList" :key="index" closable @close.prevent="closeUserTag(index)">
              {{ item.title }}
            </a-tag>
          </div>
        </a-form-item> -->
        <a-form-item
          label="群人数限制"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :min="1"
            v-decorator="[
              'ultimate',
              { rules: [{ required: true, message: '请输入群人数限制!' }] }
            ]"
            @change="numChange"
          />
          人
        </a-form-item>
        <a-form-item
          label="群活码状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <!-- 单人 -->
          <a-radio-group
            @change="ctypeChange"
            name="radioGroup"
            v-decorator="['isDisabled', { initialValue: 0 }]"
          >
            <a-radio :value="0">
              开启状态
            </a-radio>
            <a-radio :value="1">
              禁用状态
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="群活码期限"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group name="radioGroup" v-model="gBarcodeTime">
            <a-radio :value="1">
              长期有效
            </a-radio>
            <a-radio :value="2">
              区间有效
            </a-radio>
            <!-- <a-radio :value="3">
              小程序
            </a-radio> -->
          </a-radio-group>
        </a-form-item>
        <div style="margin-top: 20px">
          <div v-show="gBarcodeTime == 2">
            <a-form-item :wrapperCol="{ span: 12, offset: 5 }">
              <a-range-picker
                show-time
                v-decorator="['validTime']"
                format="YYYY/MM/DD HH:mm:ss"
                @change="dateChange"
              />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-spin>
    <!-- <depart-window ref="departWindow" @ok="modalFormOk"></depart-window> -->

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment';
import Vue from 'vue';
// 引入搜索部门弹出框的组件
import departWindow from '../../system/modules/DepartWindow';
import JSelectGroup from '@/components/jeecgbiz/JSelectGroup';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction, postTag } from '@/api/manage';
import { disabledAuthFilter } from '@/utils/authFilter';
import JImageUpload from '../../../components/jeecg/JImageUpload';
import { getCusAll } from '@/api/api';
import HttpTraceVue from '../../modules/monitor/HttpTrace.vue';

export default {
  name: 'GroupModal',
  components: {
    JImageUpload,
    departWindow,
    JSelectGroup
  },
  data() {
    return {
      gBarcodeTime: 1,
      visibleshowuser: false,
      visibleshow: false,
      visibleGroup: false,
      departTree: [],
      departTree1: [],

      autoExpandParent: true,

      checkedKeys: [], // 存储选中的id
      expandedKey: [], // 展开的节点
      tagList: [],
      departTreeOriginal: [],

      channelList: [],
      channelCheckedKeys: [], // 存储选中的id
      channelExpandedKey: [], // 展开的节点

      modalWidth: 800,
      modaltoggleFlag: true,
      disableSubmit: false,
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      url: {
        tagData:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/getAllGroupTag',
        add:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/uploadGroupBarcode',
        edit:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/updateGroupBarcode',
        detail:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/queryGroupBarcodeInfoById'
        // fileUpload: '/wechatwork-groupchat-biz/wechatwork/wechatMsg/upMaterial'
      },
      rangTime: '',
      startTime: '2019/02/04 00:00:00',
      endTime: '2019/02/24 00:00:00',
      popSearchValue: ''
    };
  },

  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token
    };
    this.initData();
  },
  computed: {
    uploadAction: function() {
      return this.url.fileUpload;
    }
  },
  // inject: ['reload'],
  methods: {
    deepDone(arr, value) {
      arr.forEach(item => {
        if (item.title.indexOf(value) > -1) {
          this.departTree.push(item);
        } else {
          if (item.children.length > 0) {
            this.deepDone(item.children, value);
          }
        }
      });
    },
    onExpand(expandedKeys) {
      this.expandedKey = expandedKeys;
      this.autoExpandParent = false;
    },
    onChangeUser(e) {
      const value = this.popSearchValue;
      const expandedKey = this.dataList;
      this.userselectedList = this.form.getFieldValue('userList');
      this.checkedKeys2 = this.checkedKeys;
      if (!value) {
        this.departTree = this.departTreeOriginal;
        this.pdlist = this.showTree;
      } else {
        this.departTree = [];
        this.deepDone(this.departTreeOriginal, value);
        this.pdlist = [];
        this.departTree.forEach(item => {
          this.pdlist.push(item);
        });
      }
    },
    dateChange(date) {
      if (date) {
        this.rangTime =
          date[0].format('YYYY/MM/DD HH:mm:ss') +
          '-' +
          date[1].format('YYYY/MM/DD HH:mm:ss');
      }
    },
    add() {
      this.edit({});
    },
    edit(record) {
      this.checkedKeys = [];
      this.channelCheckedKeys = [];
      this.model = {};
      if (record.tags) {
        this.channelCheckedKeys = record.tags.map(e => e.id);
      }
      let that = this;
      that.form.resetFields();
      if (record.id) {
        getAction(this.url.detail, {
          id: record.id
        }).then(res => {
          if (res.success) {
            this.model.name = res.result.name;
            this.model.id = record.id;
            // this.$set(this, 'model', res.result)
            let arr = [];
            res.result.groupChats.forEach((item, index) => {
              // if(index !== this.model.groupChats.length - 1) {
              //     this.model.chats = this.model.chats + item.groupChatName + ','
              // } else {
              //     this.model.chats = this.model.chats + item.groupChatName
              // }
              arr.push(item.groupChatId);
            });
            this.model.chats = arr.join(',');
            this.model.ultimate = res.result.ultimate;
            this.checkedKeys[0] = res.result.repairUserId;
            this.model.userList = [];
            this.model.userList[0] = {};
            this.model.userList[0].key = res.result.repairUserId;
            this.model.userList[0].name = res.result.repairUserName;
            this.model.userList[0].title = res.result.repairUserName;
            this.model.tags = res.result.tags.map(e => {
              return {
                key: e.id,
                value: e.id,
                title: e.name
              };
            });
            if (res.result.validTime) {
              if (res.result.validTime.includes('长期有效')) {
                this.gBarcodeTime = 1;
                this.model.validTime = undefined;
              } else {
                this.gBarcodeTime = 2;
                this.model.validTime = res.result.validTime;
              }
            }
            // this.model.validTime = this.model.gBarcodeTime ? 2 : 1
            this.rangTime = res.result.validTime;
            this.model.isDisabled = parseInt(res.result.isDisabled);
            // this.model.scene = parseInt(this.model.scene)
            console.log(this.model);
            this.initForm();
          }
        });
      } else {
        that.gBarcodeTime = 1;
        that.model = Object.assign(
          {
            isDisabled: 0
            // scene: 2,
          },
          record
        );
        this.initForm();
      }
    },
    initForm() {
      this.visible = true;
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.model.validTime) {
            this.model.validTime = this.model.validTime.split('-');
            this.model.validTime[0] = moment(this.model.validTime[0]);
            this.model.validTime[1] = moment(this.model.validTime[1]);
          }
          this.form.setFieldsValue(
            pick(
              this.model,
              'name',
              'chats',
              'ultimate',
              'isDisabled',
              'validTime',
              'userList'
            )
          );
          this.form.setFieldsValue({
            tags: this.model.tags
          });

          console.log(this.form.getFieldValue('tags'));
        }, 0);
      });
    },
    numChange() {
      console.log(this.form.getFieldValue('tags'));
    },
    closeTag(i) {
      console.log(this.model.tags, this.model);
      this.model.tags.splice(i, 1);
      this.channelCheckedKeys.splice(i, 1);
      // this.form.getFieldValue('tags').splice(i, 1)
      this.form.setFieldsValue({
        tags: this.model.tags
      });

      // console.log(this.form.getFieldValue('userList'), this.checkedKeys)
    },
    closeUserTag(i) {
      this.model.userList.splice(i, 1);
      this.checkedKeys.splice(i, 1);
      // this.form.getFieldValue('userList').splice(i, 1)
      this.form.setFieldsValue({
        userList: this.model.userList
      });

      // console.log(this.form.getFieldValue('userList'), this.checkedKeys)
    },
    ctypeChange() {
      // this.form.setFieldsValue({
      //     userList: null
      // })
      // this.checkedKeys = []
    },
    // 选择部门时作用的API
    onCheck(checkedKeys, info) {
      let userList = [];
      this.checkedKeys = checkedKeys;
      let checkedNodes = info.checkedNodes;
      for (let i = 0; i < checkedNodes.length; i++) {
        let de = checkedNodes[i].data.props;
        let depart = {
          key: '',
          value: '',
          title: '',
          parentName: ''
        };
        depart.key = de.value;
        depart.value = de.value;
        depart.title = de.title;
        depart.parentName = de.dataRef.parentid;
        userList.push(depart);
      }

      if (userList.length > 1) {
        userList = [userList[userList.length - 1]];
      }
      let checkedList = checkedKeys;
      if (checkedList.length > 1) {
        this.checkedKeys = [checkedList[checkedList.length - 1]];
      }
      this.form.setFieldsValue({
        userList
      });
      this.model.userList = userList;
    },
    onCheck1(checkedKeys, info) {
      let tags = [];
      this.channelCheckedKeys = checkedKeys;
      let checkedNodes = info.checkedNodes;
      // channelList = checkedNodes
      for (let i = 0; i < checkedNodes.length; i++) {
        let de = checkedNodes[i].data.props;
        let depart = {};
        depart.key = de.id;
        depart.value = de.id;
        depart.title = de.title;
        depart.parentName = de.dataRef.parentTagId;

        if (!de.tags || de.tags.length === 0) {
          tags.push(depart);
        }
      }
      console.log(tags);
      this.form.setFieldsValue({
        tags
      });
      this.model.tags = tags;
    },
    onExpand1(expandedKeys) {
      this.channelExpandedKey = expandedKeys;
      this.autoExpandParent = false;
    },
    initData() {
      getCusAll().then(res => {
        if (res.success) {
          this.departTree = res.result;
          this.departTreeOriginal = [...res.result];
          if (this.departTree && this.departTree.length > 0) {
            let treekey = ['0'];
            let arr = res.result;
            if (arr && arr.length > 0) {
              arr.forEach(item => {
                treekey.push(item.key);
              });
              this.expandedKey = treekey;
            }
          }
        }
      });
      getAction(this.url.tagData, {
        pageNo: 1,
        pageSize: 10
      }).then(res => {
        if (res.success) {
          this.departTree1 = res.result;
          console.log(this.departTree1);
          if (this.channelExpandedKey && this.channelExpandedKey.length > 0) {
            let treekey = [];
            let arr = res.result;
            if (arr && arr.length > 0) {
              arr.forEach(item => {
                treekey.push(item.id);
              });
              this.channelExpandedKey = treekey;
            }
          }
        }
      });
    },
    onCloseTag() {
      this.visibleshow = false;
    },
    onClose() {
      this.visibleshowuser = false;
      this.popSearchValue = '';
      this.onChangeUser();
    },
    isDisabledAuth(code) {
      return disabledAuthFilter(code);
    },
    // 窗口最大化切换
    toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }
      this.modaltoggleFlag = !this.modaltoggleFlag;
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    moment,
    handleSubmit() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true;
          let url = '';
          if (!this.model.id) {
            url = this.url.add;
          } else {
            url = this.url.edit;
          }
          // console.log(values.userList)

          let formData = Object.assign(this.model, values, {
            // users: values.userList ? values.userList.map(e => {
            //     return { id: e.key, name: e.title }
            // }) : [],
            tags: values.tags
              ? values.tags.map(e => {
                  return {
                    id: e.key,
                    name: e.title,
                    title: e.title
                  };
                })
              : []
          });
          if (this.gBarcodeTime === 1) {
            formData.validTime = '长期有效';
          } else {
            formData.validTime = this.rangTime;
          }
          // console.log(values.userList);
          // formData.repairUserId = values.userList[0].key
          postTag(url, formData).then(res => {
            if (res.success) {
              this.$message.success('操作成功');
              this.close();
              this.confirmLoading = false;
              // this.reload()
              this.$emit('searchReset');
            } else {
              this.$message.error(res.message);
              this.confirmLoading = false;
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
